import React from 'react';
import './Card.css';

export default function Card({ children, className = '', ...rest }) {
  return (
    <div className={`shared-card ${className}`} {...rest}>
      {children}
    </div>
  );
}
